import React, { useState } from "react";
import "./HdSdFilter.css";
import hdIcon from "../../hd-icon.svg";
import { Switch } from "@mui/material";
export default function HdSdFilter(props) {
  const { isHd } = props;

  const [switched, setSwitched] = useState(isHd);
  return (
    <div className="hdSdFilterContainer">
      <div className="isHdImage">
        <img src={hdIcon} alt="hdIcon" style={{ marginRight: "2%" }}></img>
      </div>

      <div className="isHdFont">
        <p> View Hd Channels</p>
      </div>

      <div className="isHdSwitch">
        <Switch
          checked={switched}
          onClick={(data) => {
            setSwitched(!switched);
            props.onHdChangeHD(!switched);
            props.scrollOnAction();
            // localStorage.setItem("lastHdValue",!switched)
            //change this value to fetch from api
          }}
        />
      </div>
    </div>
  );
}
